module.exports = __webpack_public_path__ + "static/media/lock-icon-green.02185449.svg";